











import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { ChartData, ChartOptions, ChartColor } from 'chart.js';
import { BaseChart } from 'vue-chartjs/types/components';
import { Bar, Line, Doughnut } from 'vue-chartjs';

@Component({
  name: 'bc-chart',
  components: {
    'bc-bar-chart': Bar,
    'bc-line-chart': Line,
    'bc-doughnut-chart': Doughnut,
  },
})
export default class BCChart extends Vue {
  $refs!: {
    bcChart: InstanceType<typeof BaseChart> & {
      renderChart(chartData: ChartData, options?: ChartOptions): void;
    };
  };
  @Prop({
    type: Object,
    default: () => ({
      labels: ['January', 'February', 'March'],
      datasets: [
        {
          data: [40, 20, 12],
          label: 'Label Example',
          backgroundColor: 'rgba(255,99,132,0.2)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          borderCapStyle: 'round',
        },
      ],
    }),
  })
  readonly chartData!: ChartData;
  @Prop({
    type: Object,
    default: () => ({
      responsive: true,
      maintainAspectRatio: false,
    }),
  })
  readonly chartOptions!: ChartOptions;
  @Prop({
    type: String,
    required: true,
  })
  readonly chartType: string;

  mounted() {
    this.$refs.bcChart.renderChart(this.chartData, this.chartOptions);
  }

  renderChart(chartData: ChartData, chartOptions: ChartOptions) {
    this.$refs.bcChart.renderChart(chartData, chartOptions);
  }
}
